export function getPWADisplayMode(): 'standalone' | 'browser' | 'twa' {
  if (typeof window === 'undefined') {
    return 'browser';
  }

  if (window.matchMedia('(display-mode: standalone)').matches) {
    return 'standalone';
  }

  if (window.matchMedia('(display-mode: minimal-ui)').matches) {
    return 'standalone';
  }

  if (window.matchMedia('(display-mode: fullscreen)').matches) {
    return 'standalone';
  }

  if (window.matchMedia('(display-mode: window-controls-overlay)').matches) {
    return 'standalone';
  }

  // @ts-expect-error navigator.standalone is iOS-specific
  if (window.navigator.standalone === true) {
    return 'standalone';
  }

  if (
    typeof document !== 'undefined' &&
    document.referrer &&
    document.referrer.startsWith('android-app://')
  ) {
    return 'twa';
  }

  return 'browser';
}

export function isInstalledPWA(): boolean {
  const mode = getPWADisplayMode();
  return mode === 'standalone' || mode === 'twa';
}

export function isIOS(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isAndroid(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return /Android/i.test(navigator.userAgent);
}
